import { MenuItem, TextField as MuiTextField } from "@material-ui/core";
import React, { FC } from "react";
import styled from "@emotion/styled";

const TextField = styled(MuiTextField)`
   width: 100%;
   background: #233145;
   & .MuiOutlinedInput-root {
     border-radius: 8px;
   },
   & .MuiInputBase-input {
     padding: 13.5px 13px
   },
 `

type PropsType = {
  selectedProperty: any,
  setSelectedProperty: (id: string) => void,
  listProperty: []
}

const SelectProperty: FC<PropsType> = ({selectedProperty, setSelectedProperty, listProperty}) => {
  return (
    <TextField
      id="outlined-select-currency"
      select
      variant="outlined"
      value={selectedProperty}
      onChange={(e: any) => (
        setSelectedProperty(e.target.value)
      )}
    >
      {listProperty.map((company: any, index: number) => {
        return (
          <MenuItem key={index} value={company.id}>
            {company.name}
          </MenuItem>
        )
      })}
    </TextField>
  )
}

export default SelectProperty
